import { CommentDto } from "components/comments/CommentComponent";
import { BasicComment } from "lib/generated/app-service-gql/graphql";
import type { CurrentUserData } from "lib/hooks/api/users/useCurrentUser";

export const serializeComment = (
  comment: BasicComment,
  currentUser: CurrentUserData,
): CommentDto => {
  return {
    id: comment.id,
    content: comment.content,
    createdAt: comment.createdAt,
    updatedAt: comment.updatedAt,
    author: {
      guid: currentUser.guid,
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      active: true,
    },
  };
};
